import Notification from "vue-bulma-notification";
import Vue from "vue";
import config from "configSite";
import { mapGetters } from "vuex";
import { removeToken } from "utils/auth";
import fx from "utils/fx";

const NotificationComponent = Vue.extend(Notification);
const imageExtension = ["image/gif", "image/jpeg", "image/png", "image/webp"];
const openNotification = (
  propsData = {
    title: "",
    message: "",
    type: "",
    direction: "",
    duration: 3000,
    container: ".notifications"
  }
) => {
  return new NotificationComponent({
    el: document.createElement("div"),
    propsData
  });
};

export default {
  computed: mapGetters({
    permissions: "permissions",
    profile: "profile",
    imagePlaceholder: "imagePlaceholder"
  }),
  methods: {
    checkPermissionWithSubMenu(pers = [], children = []) {
      if (pers.length <= 0 || !this.permissions) return false;

      if (children.length) {
        const listPermission = Object.keys(this.permissions);

        // Child route of router
        const childs = children
          .map(child => child?.meta?.permission?.[0].replace(/@index/, ""))
          .filter(e => e);

        // Check  permission have  at least 1 children
        let childMenu = [];

        if (pers[0].replace(/@index/, "") === "utilities") {
          // specific case like "Utilities"
          childMenu = childs
            .map(e =>
              this.permissions[pers[0].replace(/@index/, "")]?.includes(e)
            )
            .some(item => item === true);
        } else {
          // Normal case with [index, update, delete...]
          childMenu = childs
            .map(e => this.permissions[e]?.[0] === "index")
            .filter(e => e)
            .some(item => item === true);
        }

        // Check has parent route permission - check if user has ANY of the parent permissions
        const parentMenu = pers.some(permission => {
          const permissionKey = permission.replace(/@index/, "");
          return listPermission.includes(permissionKey);
        });
        
        return childMenu && parentMenu;
      }
    },
    hasPermission(pers = []) {
      if (pers.length > 0) {
        let c = 0;

        for (let i = 0; i < pers.length; i++) {
          let arr = pers[i].split("@");

          if (this.permissions) {
            if (this.permissions[arr[0]]) {
              if (this.permissions[arr[0]].indexOf(arr[1]) < 0) {
                c++;
              }
            } else {
              c++;
            }
          } else {
            return false;
          }
        }

        return c !== pers.length;
      }

      return true;
    },

    hasPermissionMenu(pers = [], test = null) {
      if (pers.length <= 0 || !this.permissions) return false;

      if (test?.meta?.label === "Utilities") {
        // Render sub-menu with specific case
        return this.checkPermissionWithSubMenu(
          test.meta.permission,
          test.children
        );
      }

      let c = 0;

      for (let i = 0; i < pers.length; i++) {
        let arr = pers[i].split("@");

        if (this.permissions[arr[0]]) {
          if (this.permissions[arr[0]].indexOf(arr[1]) < 0) {
            c++;
          }
        } else {
          c++;
        }
      }

      return c !== pers.length;
    },
    checkPermission(pers = "") {
      let check = false;
      Object.keys(this.permissions).map(el => {
        this.permissions[el].map(val => {
          if (val === pers[0]) {
            check = true;
          }
        });
      });
      return check;
    },
    logout() {
      removeToken();
      this.$store.dispatch("user/setPermissions", null);
      this.$store.dispatch("profile", null);
      this.$router.push({ name: "login" });
    },
    isImage(file) {
      if (file && file.type && imageExtension.indexOf(file.type) > -1)
        return true;

      return false;
    },
    openNotificationWithType(type, data) {
      openNotification({
        title: data.title,
        message: data.message,
        type: type
      });
    },
    formatErrorMessages(error) {
      let errors = error.response.data.error.errors;
      let message = [];
      Object.values(errors).map(value => {
        message.push(value[0]);
      });
      return message.join("\n");
    },
    formatShowError(error, message, redirect) {
      if (error.response.status == 404 || error.response.code == 404) {
        if (!redirect) {
          this.$router.push({ path: "/404" });
        }

        this.openNotificationWithType("danger", {
          title: "Error",
          message: error.response.data.error.message
        });

        return;
      }

      if (error.response.status == 422) {
        let listErr = error.response.data.error.errors;
        Object.keys(listErr).map(p => {
          listErr[p].map(ro => {
            this.openNotificationWithType("danger", {
              title: "Error",
              message: ro
            });
          });
        });
        return;
      }

      if (message) {
        this.openNotificationWithType("danger", {
          title: "Error",
          message: message
        });
      }

      if (!message) {
        this.openNotificationWithType("danger", {
          title: "Error",
          message: error.response.data.error.message
        });
      }
    },
    orderLabel(label) {
      return (
        '<span style="width:100%;" class="tag ' +
          config.orderLabel[label] +
          '">' +
          label +
          "</span>" || ""
      );
    },
    label(label) {
      return (
        '<span style="width:100%;" class="tag ' +
          config.orderLabel[label] +
          '">' +
          label +
          "</span>" || ""
      );
    },
    formatPrice(value) {
      let val = value;
      if (typeof value === 'number') {
        val = Math.floor(value);
      } else {
        let cleanNumStr = val.replace(/,/g, "");
        val = cleanNumStr.split('.')[0];
      }

      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatNumber(value) {
      let val = value;
      if (typeof value === 'number') {
        val = Math.floor(value);
      } else {
        let cleanNumStr = val.replace(/,/g, "");
        val = cleanNumStr.split('.')[0];
      }

      return Number(val);
    },
    formatNumberWithCommas(value) {
      return fx.numberWithCommas(parseInt(value));
    },
    successFailLabel(label) {
      switch (label) {
        case "success":
        case "SUCCESS":
        case "active":
        case "ACTIVE":
        case "COMPLETED":
        case "subscribed":
          return '<span  class="tag is-small is-success">' + label + "</span>";
        case "cancel":
        case "CANCEL":
        case "cancelled":
        case "canceled":
        case "CANCELLED":
        case "CANCELED":
        case "FAILED":
        case "spam":
          return '<span class="tag is-small is-danger">' + label + "</span>";
        case "waiting":
        case "WAITING":
        case "CREATED":
        case "confirm":
        case "unsubscribed":
          return '<span class="tag is-small is-warning">' + label + "</span>";
        case "APPROVED":
        case "shipping":
        case "SHIPPING":
          return '<span class="tag is-small is-primary">' + label + "</span>";
        case "processing":
        case "PROCESSING":
          return '<span class="tag is-small is-info">' + label + "</span>";
        default:
          return '<span class="tag is-small is-light">' + label + "</span>";
      }
    },
    statusShipper(shipper_valid, date) {
      if (shipper_valid === 0) {
        return '<i class="shipper-status fa fa-2x fa-times-circle is-danger"></i>';
      }

      if (shipper_valid === 1) {
        if (!date) date = "";

        return (
          '<span class="pickup-date-status">' +
          date +
          ' </span><i class="shipper-status fa fa-2x fa-check-circle is-success"></i>'
        );
      }

      return '<i class="shipper-status fa fa-2x fa-clock-o is-warning-status"></i>';
    },
    // funciton to compare 2 array return boolean
    compareArr(array1, array2) {
      let is_same =
        array1.length == array2.length &&
        array1.every((element, index) => {
          return element === array2[index];
        });
      return is_same;
    },
    // format type: abc_def
    replaceUnderscore(string) {
      if (!string) return "";

      return string
        .toString()
        .split("_")
        .map(k => {
          return k[0].toUpperCase() + k.substr(1);
        })
        .join(" ");
    },
    toUpperCase(data) {
      return data.charAt(0).toUpperCase() + data.slice(1);
    },
  }
};
